import { defineMessages } from 'react-intl';

export default defineMessages({
  mfFormLabel: {
    id: 'mf.mfform.placeholder.generic',
    defaultMessage: 'Verification code',
    description:
      'Placeholder hint for the verification code textfield when the expected code length is unknown',
  },
  mfFormLabelNDigits: {
    id: 'mf.mfform.placeholder.ndigits',
    defaultMessage: '{codeLength}-digit verification code',
    description: '',
  },
  mfFormLabelNCharacters: {
    id: 'mf.mfform.placeholder.ncharacters',
    defaultMessage:
      '{codeLength, plural, one {# character} other {# characters}} verification code',
    description: '',
  },
  errorsInvalidOtp: {
    id: 'mf.mfform.errors.invalid_otp',
    defaultMessage: 'You entered an incorrect verification code.',
  },
  errorsInvalidOtpFormat: {
    id: 'mf.mfform.errors.invalid_otp_format',
    defaultMessage: 'You entered an invalid verification code.',
  },
  errorsInvalidOtpPattern: {
    id: 'mf.mfform.errors.invalid_otp_pattern',
    defaultMessage:
      'Your verification code needs to be {codeLength, plural, one {# character} other {# characters}}.',
  },
  errorsExpiredOtp: {
    id: 'mf.mfform.errors.expired_otp',
    defaultMessage: 'Your verification code has expired.',
  },
  errorsUnknown: {
    id: 'mf.mfform.errors.unknown',
    defaultMessage: 'Unknown error occurred. Please try again.',
  },
});
